<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<div class="content">
  <mat-card>
    <mat-card-title>User Information</mat-card-title>
    <mat-card-content>
      <p><strong>Username:</strong> {{ details.username }}</p>
      <p><strong>Tournaments started:</strong> {{ details.startedTournaments }}</p>
      <p><strong>Tournaments not started:</strong> {{ details.notStartedTournaments }}</p>
      <p><strong>List of Tournaments:</strong></p>
      <ul>
        @for (tournament of details.tournaments; track tournament) {
          <li>{{ tournament }}</li>
        } @empty {
          <li>Currently no tournaments exist.</li>
        }
      </ul>
    </mat-card-content>
    <mat-card-actions>
      <button mat-raised-button (click)="onChange()">
        <mat-icon>edit</mat-icon> Change Information
      </button>
      <button mat-flat-button class="delete-button" (click)="onDelete()">
        <mat-icon>delete</mat-icon> Delete your Account
      </button>
      <button mat-button class="delete-button" (click)="genTestData()">Generate Testdata</button>
    </mat-card-actions>
  </mat-card>
</div>
